import * as React from 'react';
const SvgMedRegs = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M122 104.581V42.645c0-9.62-7.8-17.42-17.419-17.42h-9.678v61.936h9.678c9.619 0 17.419 7.8 17.419 17.42Zm0 0C122 114.2 114.2 122 104.581 122H2V50.387h9.677"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m40.71 75.936-17.42 9.29 29.032 17.419 29.033-17.42-17.42-9.29M34.898 24.452l17.425 10.451 17.419-10.451"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M81.355 50.387V17.484L52.322 2 23.29 17.484M23.29 17.484v32.903M52.322 56.194v-21.29M23.29 50.387l29.032 17.42M52.322 67.807l29.033-17.42"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgMedRegs;
